module.exports = __webpack_public_path__ + "static/media/Screenshotpage3.3dd8c031.png";